import React from 'react';
type EmphasisLinesProps = {
  lines: string[];
  className?: string;
};
export function EmphasisLines({
  lines,
  className = ''
}: EmphasisLinesProps) {
  return <div className={`text-center font-display text-xl font-extrabold uppercase leading-snug md:text-2xl ${className}`} data-id="element-28" data-mp="3njrkif8ae9sl">
      {lines.map((line, i) => <p key={line} className={i === lines.length - 1 ? 'text-cyan-400' : 'text-white'} data-id="element-29" data-mp="16sz43pza5hv" data-mpi={i}>
          {line}
        </p>)}
    </div>;
}